<template>

  <div class="main-wrapper" ref="root">
    <!--
    <fullscreen v-model="fullscreen">
    -->


    <!---
        <div class="index-container" v-show="false">
          <audio controls="controls" :src="sound1" ref="audio1"></audio>
        </div>
        <div class="index-container" v-show="false">
          <audio controls="controls" :src="sound2" ref="audio2"></audio>
        </div>
        <div class="index-container" v-show="false">
          <audio controls="controls" :src="sound3" ref="audio3"></audio>
        </div>
        <div class="index-container" v-show="false">
          <audio controls="controls" :src="sound4" ref="audio4"></audio>
        </div>
        <div class="index-container" v-show="false">
          <audio controls="controls" :src="sound5" ref="audio5"></audio>
        </div>
    -->

        <!---
          ***********************************************************************************
          *******************************    Index Page    *******************************
          ***********************************************************************************
          v-if="false"
        --->
    <div class="index-container" v-show="systemState==0">
      <div class="index" @click="indexClick">
        <span><img src="../assets/vehicle/Touch.png" alt class="index-logo" /></span>
        <span class="index-txt">タッチしてください</span>
      </div>
      <img src="../assets/vehicle/mopi_logo.png" class="mainlogo">
    </div>




    <!---
              ***********************************************************************************
              *******************************    Travel Page    *******************************
              ***********************************************************************************
              v-if="false"
            --->
    <div class="travelClass" v-show="systemState==3">

      <div class="travelTitleClass"> task </div>

      <div class="travelLineClass"> {{curTime}}</div>

      <div class="travelLineClass" v-if="emptyOrder==0"> {{travelSourceDestText}}</div>
      <div class="travelLineClass" v-if="emptyOrder==0"> {{travelSourceTime}}</div>
      <div class="travelLineClass" v-if="emptyOrder==0"> {{travelPassenger}}</div>

      <div class="travelPassLineClass" v-if="emptyPassenger==0">
        <div class="travelPassNameClass"> {{travelPassengerName1}} </div>
        <select v-model="selectPassengerCount1" class="travelCountoptionbox" @change="selectPassengerChange1">
          <option v-for="selectPassengerValue1 in selectPassengerValues" :value="selectPassengerValue1.name" :key="selectPassengerValue1.id">{{ selectPassengerValue1.name }}</option>
        </select>
      </div>
      <div class="travelPassLineClass" v-if="emptyPassenger==0">
        <div class="travelPassNameClass"> {{travelPassengerName2}} </div>
        <select v-model="selectPassengerCount2" class="travelCountoptionbox" @change="selectPassengerChange2">
          <option v-for="selectPassengerValue2 in selectPassengerValues" :value="selectPassengerValue2.name" :key="selectPassengerValue2.id">{{ selectPassengerValue2.name }}</option>
        </select>
      </div>
      <div class="travelPassLineClass" v-if="emptyPassenger==0">
        <div class="travelPassNameClass"> {{travelPassengerName3}} </div>
        <select v-model="selectPassengerCount3" class="travelCountoptionbox" @change="selectPassengerChange3">
          <option v-for="selectPassengerValue3 in selectPassengerValues" :value="selectPassengerValue3.name" :key="selectPassengerValue3.id">{{ selectPassengerValue3.name }}</option>
        </select>
      </div>
      <div class="travelPassLineClass" v-if="emptyPassenger==0">
        <div class="travelPassNameClass"> {{travelPassengerName4}} </div>
        <select v-model="selectPassengerCount4" class="travelCountoptionbox" @change="selectPassengerChange4">
          <option v-for="selectPassengerValue4 in selectPassengerValues" :value="selectPassengerValue4.name" :key="selectPassengerValue4.id">{{ selectPassengerValue4.name }}</option>
        </select>
      </div>
      <div class="travelPassLineClass" v-if="emptyPassenger==0">
        <div class="travelPassNameClass"> {{travelPassengerName5}} </div>
        <select v-model="selectPassengerCount5" class="travelCountoptionbox" @change="selectPassengerChange5">
          <option v-for="selectPassengerValue5 in selectPassengerValues" :value="selectPassengerValue5.name" :key="selectPassengerValue5.id">{{ selectPassengerValue5.name }}</option>
        </select>
      </div>
      <div class="travelPassLineClass" v-if="emptyPassenger==0">
        <div class="travelPassNameClass"> {{travelPassengerName6}} </div>
        <select v-model="selectPassengerCount6" class="travelCountoptionbox" @change="selectPassengerChange6">
          <option v-for="selectPassengerValue6 in selectPassengerValues" :value="selectPassengerValue6.name" :key="selectPassengerValue6.id">{{ selectPassengerValue6.name }}</option>
        </select>
      </div>


      <div class="travelLineClass" v-if="emptyOrder==0 && emptyPassenger==1"> 乗客なし </div>

      <div class="travelOrderEmptyClass" v-if="emptyOrder==1"> タスクなし</div>

      <div class="travelButtonClass" @click="travelButtonClick" v-if="emptyOrder==0" > {{ travelButtonText }} </div>


    </div>







    <!---
      ***********************************************************************************
      *******************************    User Page    *******************************
      ***********************************************************************************
      v-if="false"
    --->
    <!---------------------- Left Side Name Selection State=0 -------------------- v-if="false" -->
    <div class="mainPanel" v-show="systemState==1" v-if="false">

      <div class="mainPanelCenterContent">
        <div class="value">{{userNameString}}</div>
      </div>
    </div>
    <!---------------------- Right Side Name Yes/No Bar ---------------------->
    <div class="haveOrder" v-show="systemState==1">
      <div class="yesBlk">
        <button
            class="stationButtonOdd"
            @click="clickBtnNameYes"
        >はい
        </button>
      </div>

      <div class="noBlk">
        <button
            class="stationButtonEven"
            @click="clickBtnNameNo"
        >いいえ
        </button>
      </div>
    </div>





















    <!---
      ***********************************************************************************
      *******************************    Left Side Bar    *******************************
      ***********************************************************************************
      v-if="false"
    --->

    <!-----------------------------------------------------------------------
      ------------------------------ Starting -------------------------------
      ---------------------------------------------------------------------->
    <div class="main" v-if="isStart && !isStop && systemState==2">

      <div class="header">
        <div class="sign">
          <mg src="../assets/publicroad/uparrow.png" />
        </div>
      </div>

      <div class="speed_block">
        <div class="speed">{{veh_speed}}</div>
        <div class="unit">km/h</div>
      </div>

      <div class="split">
        <div class="line"></div>
      </div>

      <div class="body">
        <div class="stop_logo">
          <img src="../assets/publicroad/next stop.png" />
        </div>
      </div>

      <div class="station_block">
        <div class="next_station">次の停車スポット</div>
        <div class="station_name">{{next_station_name}}</div>
      </div>


      <div class="footer">
        <button
            class="start"
            @click="clickBtn"
            :style="{backgroundColor: '#F31E22'}"
            >Stop
        </button>
      </div>
    </div>






    <!-----------------------------------------------------------------------
      ------------------------------ Stopping -------------------------------
      ---------------------------------------------------------------------->
    <div class="main" v-if="!isStart && !isStop && systemState==2">

      <div class="body">
        <div class="stop_logo">
          <img src="../assets/publicroad/next stop.png" />
        </div>
      </div>

      <div class="station_block">
        <div class="next_station">次の停車スポット</div>
        <!-- <div class="station_name">{{current_station_name}}</div> -->
        <div class="station_name">{{next_station_name}}</div>
      </div>

      <div class="body">
        <div class="car_logo">
          <img src="../assets/publicroad/8seater.png" />
        </div>
      </div>

      <div class="footer">
        <button
            class="start"
            @click="clickBtn"
            :style="{backgroundColor: '#13b49b'}"
            >Start
        </button>
      </div>
    </div>



    <!-----------------------------------------------------------------------
      ------------------------------   Pausing   ----------------------------
      ---------------------------------------------------------------------->
    <div class="main" v-if="isStop && systemState==2">

      <div class="body">
        <div class="stopsign_logo">
          <img src="../assets/publicroad/Stopsign.png" />
        </div>
      </div>

      <!--
      <div class="station_block">
        <div class="stop_sign_1">安全を確認して</div>
        <div class="stop_sign_2">Start</div>
        <div class="stop_sign_3">してください</div>
      </div>
      -->


      <div class="footer">
        <button
            class="start"
            @click="clickBtn"
            :style="{backgroundColor: '#13b49b'}"
        >Start
        </button>
      </div>
    </div>


    <!---
      ***********************************************************************************
      *******************************         Map Page    *******************************
      ***********************************************************************************
    --->
    <div class="map" v-show="systemState==2">
      <div class="home" @click="backToLang" v-if="false">
        <img src="../assets/home.png" height="48" width="48" />
      </div>

      <div class="logo" v-if="false">
        <img src="../assets/logo.png" />
      </div>
      <!--    <div class="log" @click="moduleStart = true">
                <img src="../assets/5.png" />
           </div>
      -->
      <div class="phone" @click="toggleDir" v-if="false">
        <img src="../assets/publicroad/downarrow.png" v-if="isGo"/>
        <img src="../assets/publicroad/uparrow.png" v-if="!isGo"/>
      </div>

      <div class="close" @click="visibleClose = true" v-if="false">
        <img src="../assets/close.png" />
      </div>
    </div>

























    <!------------------------ OLD Main ------------------------
    -------------------------------------------------------------->
    <div class="main" v-if="false">

      <div class="header">
        <div class="time">{{time}}</div>
        <div class="sign">
          <img :src="signSrc" />
        </div>
      </div>

      <div class="speed">{{carInfo.speed}}</div>
      <div class="info">
        <gear :position="carInfo.gearPosition"></gear>
        <div class="unit">KM/H</div>
        <battery :power="carInfo.batteryLevel"></battery>
      </div>

      <div class="split">
        <div class="line"></div>
        <picture>
          <source media="(min-width:2048px)" srcset="../assets/2048/block.png" />
          <img src="../assets/1920/block.png" class="block" />
        </picture>
      </div>


      <div class="wheel">
        <img
          :src="autoOrManual"
          style="height: 60px;"
          :style="{transform: `rotate(${rotate}deg)`}"
          s
        />
      </div>
      <div class="drive" ref="drive">
        <img src="../assets/publicroad/car.png" class="stopCar" v-if="!isStart && !isTurn" />
        <road
          :obstacles="obstacles"
          :roadHeight="roadHeight"
          :roadWidth="roadWidth"
          v-show="isStart && !isTurn"
        ></road>
        <div class="mask" v-if="isTurn && isStart">
          <img :src="turnSrc" />
        </div>
      </div>
      <div class="msg">
        <div class="station">
          <div class="key">{{$t('next')}}</div>
          <div class="value">{{station.name}}</div>
        </div>
        <div class="duration">
          <div class="key">{{$t('duration')}}</div>
          <div class="value">{{station.time}}</div>
        </div>
      </div>

      <div class="footer">
        <div class="temp" v-if="isStart" @click="tempHandler">
          <img :src="tempSrc" />
        </div>
        <button
          class="start"
          @click="operate"
          :style="{backgroundColor: !isStart ? 'rgba(65, 60, 249, 1)' : '#F31E22'}"
        >{{!isStart ? 'START' : 'STOP'}}</button>
      </div>
    </div>








    <!---
      ***********************************************************************************
      *******************************          Popup      *******************************
      ***********************************************************************************
    --->

    <popup
      v-model="visible"
      :text="$t('start')"
      @onConfirm="gotoDest"
      :name="stationName"
      :src="stationUrl"
      :duration="stationTime"
    ></popup>

    <popup v-model="moduleReboot" :text="$t('confirm')" height="28%" @onConfirm="moduleStart">
      <div class="shut">{{$t('moduleStart')}}?</div>
    </popup>

    <popup v-model="visibleClose" :text="$t('confirm')" height="28%" @onConfirm="shutDown">
      <div class="shut">{{$t('shut')}}?</div>
    </popup>

    <popup v-model="websocketConnecting" :text="$t('confirm')" height="28%">
      <div class="shut">{{$t('connecting')}}...</div>
    </popup>


      <!--
      </fullscreen>
      -->

  </div>



</template>





<script>

//https://github.com/mirari/vue-fullscreen
// npm install vue-fullscreen
import Vue from "vue";
import VueFullscreen from 'vue-fullscreen';
Vue.use(VueFullscreen)

import { wgs84togcj02 } from "coordtransform";
import moment from "moment";
import Gear from "../components/gearposition";
import Battery from "../components/battery";
import Road from "../components/road";
import Popup from "../components/popup";

import { w3cwebsocket } from "websocket";

import { imgs, mapMarker, carUp, carDown, WSURL, BroadcastUrl } from "../utils/indexNara2";

import {route, station, station_point, station_name, stop_pos} from "../utils/routeNara2";


//import sound1 from '../assets/1.mp3'
//import sound2 from '../assets/2.mp3'
//import sound3 from '../assets/new3.mp3'   // 11082021
//import sound4 from '../assets/4.mp3'
//import sound4s from '../assets/4s.mp3'
//import sound5 from '../assets/5.mp3'

import * as Axios from "axios";

let { sign, auto, manual, start, stop, right, left } = imgs;

export default {
  name: "app",

  components: {
    Gear,
    Battery,
    Road,
    Popup
  },



  // ********************************************************************************************
  // ***************************                  Data           ********************************
  // ********************************************************************************************
  data() {
    return {
      //sound1: sound1,
      //sound2: sound2,
      //sound3: sound3,
      //sound4: sound4s,
      //sound5: sound5,

      //websocket实例

      fullscreen: false,

      client: null,
      BroadClient: null,
      map: null,
      truemap: null,

      A_TO_B: "復原資料情報館 から 踏切北側広場",
      B_TO_A: "踏切北側広場 から 復原資料情報館",
      TRAVEL_START_TEXT:"開始",
      TRAVEL_COMPLETE_TEXT:"完了",
      TRAVEL_STATUS_COMPLETE: 0,
      TRAVEL_STATUS_START: 1,

      curTime:"",
      travelStatus: 0,
      travelStatusDirection: 0,
      travelRealStartTime : 0,
      travelStartTime: 0,
      travelSourceDestText:"復原資料情報館 から 踏切北側広場",
      travelSourceDest: 0,
      travelSourceTime:"出発時間: ",
      travelPassenger:"乗客情報",
      travelPassengerName1:"やまだ",
      selectPassengerCount1:3,
      travelPassengerName2:"スズキ",
      selectPassengerCount2:2,
      travelPassengerName3:"やまだ",
      selectPassengerCount3:3,
      travelPassengerName4:"スズキ",
      selectPassengerCount4:2,
      travelPassengerName5:"やまだ",
      selectPassengerCount5:3,
      travelPassengerName6:"スズキ",
      selectPassengerCount6:2,

      travelButtonText:"開始",
      emptyPassenger:1,
      emptyOrder:1,

      selectPassengerValues:[
        { name: "0", id: 0 },
        { name: "1", id: 1 },
        { name: "2", id: 2 },
        { name: "3", id: 3 },
        { name: "4", id: 4 },
        { name: "5", id: 5 },
        { name: "6", id: 6 },
      ],








      //小车车速、电量以及挡位情况
      carInfo: {
        speed: 50,
        batteryLevel: 1,
        gearPosition: "P"
      },

      //当前时间
      time: "",
      //障碍物
      obstacles: [],
      //左转、右转等标志
      signSrc: sign[4],
      //自动/手动驾驶
      isAuto: false,
      timer: null,
      isTempStart: true,
      tempSrc: stop,
      //下一站点信息
      station: {
        name: "",
        time: ""
      },
      //转弯
      isTurn: false,
      turnSrc: "",
      //重连timer
      reconnectionTimer: null,
      roadHeight: 0,
      roadWidth: 0,
      //是否展示弹窗
      visible: false,
      stationName: "",
      stationTime: "",
      stationUrl: "",
      //是否展示关机弹窗
      visibleClose: false,
      moduleReboot: false,
      //display connecting info
      websocketConnecting: false,

      //方向盘转换角度
      rotate: 0,


      // ----- Public Road -----
      //底层按钮操作相关变量
      isStart: false,
      isStop: false,    // in STOP sign
      isGo: false,       // Direction Go (top to bottom) or Back (bottom to top)
      current_station_name: "Bus stop 1",
      //next_station_name: "復元事業情報館",
      next_station_name: "Bus stop 1",
      route_point: 0,
      map_route_point: 9000,
      loc_lat: 34.69212695816,
      loc_long: 135.79309902602,
      loc_heading: 0,
      veh_speed: 29,
      loc_polyline: null, // route
      marker: null,       // 小车标注
      station_margin: 0.00015,
      heading_margin: 0.3,
      station_point_margin: 20,

      MAXSTATION: 165,

      sample_interval: 1000,

      systemState: 0,
      cueSize: 0,
      objcue: [
        {username: "", passenger: 0},
        {username: "", passenger: 0},
        {username: "", passenger: 0},
        {username: "", passenger: 0},
        {username: "", passenger: 0},
      ],

      target_heading_lower: [
        330,      // reset start
        330,      // 1  0 +/- 30
        150,      // 2  180 +/- 30
        105,      // 3  135 +/-30
        230,    // 4 270-40     //185,      // 4  225 +/- 40
        330,      // 5  0 +/- 30
      ],
      target_heading_upper: [
        30,       // reset start
        30,       // 1  0 +/- 30
        210,      // 2  180 +/- 30
        165,      // 3  135 +/-30
        310,    // 4 270+40            //265,      // 4  225 +/- 40
        30,       // 5  0 +/- 30
      ],


      //sound1_played: false,
      //sound2_played: false,
      //sound3_played: false,
      //sound4_played: false,
      //sound5_played: false,

      music_station: [
        0,        // reset start
        5,        // 1
        46,       // 2
        90,       // 3
        125,      // 4
        155,      // 5
      ],

    };
  },



  // ********************************************************************************************
  // ***************************                  Computed       ********************************
  // ********************************************************************************************
  computed: {
    autoOrManual() {
      return this.isAuto ? auto : manual;
    }
  },

  // ********************************************************************************************
  // ***************************                  Created        ********************************
  // ********************************************************************************************
  created() {

    console.log(" ***** Creatrd *****");

    //this.updateTime();
    //this.createWS();
    this.createBroadcast();
  },


  // ********************************************************************************************
  // ***************************                  Mounted        ********************************
  // ********************************************************************************************
  mounted() {

    console.log(" ***** Mounted *****");


    // Axios.get("/map_region").then(({ data }) => {
    // let { china_region } = data;

    this.initMap();

    this.destAddress = "";
    this.destName = this.destAddress + "に向かいます";
    this.userNameString = "樣ですか?";
    this.cueSize=0;
    this.systemState=0; // 0=chk user name, 1=select destination, 2=confirm destination, 3=running
    //this.cueSize=2;                          // debug
    //this.objcue[0].username = "测试员1";      // debug
    //this.objcue[0].passenger=3;              // debug
    //this.objcue[1].username = "测试员2";      // debug
    //this.objcue[1].passenger=3;              // debug



    this.travelStatusDirection = 0;
    this.travelStatus = this.TRAVEL_STATUS_COMPLETE;
    this.travelButtonText = this.TRAVEL_START_TEXT;

    if(!("geolocation" in navigator))
    {
      console.log("Geolocation NOT supported");
    }
    else
    {
      this.gps_timer();
    }
  },






  methods: {

    // ********************************************************************************************
    // ***************************              Map   Code         ********************************
    // ********************************************************************************************

    //初始化地图
    initMap() {

      let normalMap = this.L.tileLayer(
          "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
          {
            attribution:
                '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          }
      );

      this.truemap = document.querySelector(".map");
      console.log("Width : " + this.truemap.clientWidth + " Height : " + this.truemap.clientHeight);

      this.map = this.L.map(document.querySelector(".map"), {
        zoom: 18,
        //center: [34.69231126388404, 135.79326182530455],
        center: [34.71498799067, 135.36178673514],
        layers: [normalMap],
        preferCanvas: true,
        zoomControl: false,
      });

      //this.map.zo

      //删除LeafLet右下角logo
      document.querySelector(".leaflet-control-attribution").style.display = "none";

      //this.chk_station()
      this.drawRoute();
      this.drawMarker();

      setTimeout(function() { window.dispatchEvent(new Event('resize')) }, 500);

    },


    drawRoute()
    {
      //if (this.route_point == this.map_route_point)
      //  return;
      //this.map_route_point = this.route_point;

      let i;
      let points = [];
      for (i = 0; i<route.length; i++){    // from start or route points
        points.push(route[i]);
        //console.log("Points : " + points[i]);
      }

      // ---------- Draw Route Line ---------
      if (this.loc_polyline!=null){
        this.map.removeLayer(this.loc_polyline);
      }

      {
        this.loc_polyline = this.L.polyline(points, {
          color: "#13b49b",
          weight: 6
        }).addTo(this.map);
      }

      // ---------- Update Car Marker ---------
      let position= [this.loc_lat, this.loc_long];
      let heading= this.loc_heading;
      if (this.marker) {
        this.map.removeLayer(this.marker);
      }// else
      {
        this.marker = this.drawCar(position, heading);
      }

    },


    drawCar(point, heading)
    {
      let icon = this.L.icon({
        iconUrl: carUp,
        iconSize: [31, 44]
      });
      return this.L.marker(point, {
        icon,
        zIndexOffset: 100,
        //rotationAngle: heading,
        rotationOrigin: "center center"
      }).addTo(this.map);

      /*
      //let icon = this.L.icon({
      //  iconUrl: mapMarker,
      //  iconSize: [40, 40]
      //});
      if (this.isGo)
      {
        let icon = this.L.icon({
          iconUrl: carDown,
          iconSize: [31, 44]
        });
        return this.L.marker(point, {
          icon,
          zIndexOffset: 100,
          //rotationAngle: heading,
          rotationOrigin: "center center"
        }).addTo(this.map);
      }
      else
      {
        let icon = this.L.icon({
          iconUrl: carUp,
          iconSize: [31, 44]
        });
        return this.L.marker(point, {
          icon,
          zIndexOffset: 100,
          //rotationAngle: heading,
          rotationOrigin: "center center"
        }).addTo(this.map);
      }
      */

    },

    gps_timer()
    {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        navigator.geolocation.getCurrentPosition(pos => {
          //console.log("Geolocation: " + pos);
          //console.log("Geolocation: " + pos.coords.latitude + " " + pos.coords.longitude);
          this.loc_lat = pos.coords.latitude;
          this.loc_long= pos.coords.longitude;
          this.getCurTime()

          this.BroadcastSend(
              JSON.stringify({
                type: "nara2023UpdateGPS",
                status: this.travelStatus,                // 0=no move, 1=moving
                direction: this.travelStatusDirection,    // 0=null, 1=A->B, 2=B->A
                latitude: this.loc_lat,
                longitude: this.loc_long
              })
          );

        }, err => {
          console.log("Geolocation Error: " + err.message);
        })
      }, 1000);
    },

    getCurTime()
    {
      let current = new Date();
      this.curTime = current.getHours() + "時" + current.getMinutes() + "分" + current.getSeconds();

      //console.log("Date: " + current.getHours())
    },




    selectPassengerChange1()
    {
      console.log("***** Selected Count 1: " + this.selectPassengerCount1);
    },

    selectPassengerChange2()
    {
      console.log("***** Selected Count 2: " + this.selectPassengerCount2);
    },
    selectPassengerChange3()
    {
      console.log("***** Selected Count 3: " + this.selectPassengerCount3);
    },
    selectPassengerChange4()
    {
      console.log("***** Selected Count 4: " + this.selectPassengerCount4);
    },
    selectPassengerChange5()
    {
      console.log("***** Selected Count 5: " + this.selectPassengerCount5);
    },
    selectPassengerChange6()
    {
      console.log("***** Selected Count 6: " + this.selectPassengerCount6);
    },


    travelButtonClick()
    {
      console.log("Travel Button Click");
      let current = new Date()

      // Go Start move
      if (this.travelStatus==this.TRAVEL_STATUS_COMPLETE)
      {
        this.travelStatus= this.TRAVEL_STATUS_START
        this.travelButtonText = this.TRAVEL_COMPLETE_TEXT
        this.travelRealStartTime = current.getHours()*100 + current.getMinutes();

        console.log("***** Started order time: "+this.travelStartTime + "  Dest: "+this.travelSourceDest);
        this.BroadcastSend(
            JSON.stringify({
              type: "nara2023StartCurrentOrder",
              StartTime: this.travelStartTime,
              SourceDest: this.travelSourceDest,
            })
        );
      }
      // Start to Finish
      else
      {
        console.log("***** Finish order time: "+this.travelStartTime + "  Dest: "+this.travelSourceDest);
        this.BroadcastSend(
            JSON.stringify({
              type: "nara2023FinishCurrentOrder",
              StartTime: this.travelRealStartTime,
              StopTime: current.getHours()*100 + current.getMinutes(),
              SourceDest: this.travelSourceDest,
              PassengerName1: this.travelPassengerName1,
              PassengerCount1: this.selectPassengerCount1,
              PassengerName2: this.travelPassengerName2,
              PassengerCount2: this.selectPassengerCount2,
              PassengerName3: this.travelPassengerName3,
              PassengerCount3: this.selectPassengerCount3,
              PassengerName4: this.travelPassengerName4,
              PassengerCount4: this.selectPassengerCount4,
              PassengerName5: this.travelPassengerName5,
              PassengerCount5: this.selectPassengerCount5,
              PassengerName6: this.travelPassengerName6,
              PassengerCount6: this.selectPassengerCount6
            })
        );
      }

    },



    requestCurrentOrder()
    {
      this.BroadcastSend(JSON.stringify({type: "nara2023GetCurrentOrder"}));
    },





    // ********************************************************************************************
    // ***************************        WebSocket to Engine      ********************************
    // ********************************************************************************************
    //建立websocket连接
    createWS() {
      this.client = new w3cwebsocket(WSURL);

      this.client.onerror = (evt) => {
        console.log("WebSocket Error : " + WSURL);
        //断线自动重连
        this.createWS();
      };

      this.client.onopen = () => {
        console.log("WebSocket Client Connected");
        this.websocketConnecting =false;
      };

      this.client.onclose = (evt) => {
        console.log("WebSocket Closed : " + WSURL);
        //断线自动重连
        this.createWS();
      };

      this.client.onmessage = (evt) => {
        this.tcpCallback(evt.data);
      };

      //每秒刷新当前车辆状态
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (this.client.readyState === this.client.OPEN) {
          this.requestSimulationWorld();
          this.requestRealTimeRoute();
        }
      }, this.sample_interval);
    },

    //获取车辆状态信息和环境信息 (100ms per request)
    requestSimulationWorld() {
      this.send({
        type: "RequestSimulationWorld"
      });
    },
    // 获取实时站点信息 (1s per request)
    requestRealTimeRoute() {
      this.send({
        type: "RequestRealTimeNavigation"
      });
    },
    //发送消息
    send(param) {
      this.client.send(JSON.stringify(param));
    },


    // "type":"HMIStatus","timestamp":1599566463627,"modes":0,"current_mode":0,"enable_log":false,"enable_phone_call":false}
    //tcp回调
    tcpCallback(res)
    {
      //console.log("Received from Engine 7777: " + res);

      this.BroadcastSend(res);    // Engine -> Tablet -> 8888 Server

      if (res.indexOf("{") > -1)
      {
        let data = JSON.parse(res);
        //console.log(data);
        if (data.type === 'AutoDrivingCar')
        {
          this.veh_speed= data.speed.toFixed(0);
          this.loc_lat= data.latitude;
          this.loc_long= data.longitude;
          this.loc_heading= data.heading;

          //console.log("++++++++++++++++++++++++++++++++++++++++++");
          console.log("+++++ lat long heading speed: " + this.loc_lat.toFixed(5) +" " + this.loc_long.toFixed(5) +" " + this.loc_heading.toFixed(2) +" " + this.veh_speed);
          //console.log("+++++ Heading : " + this.loc_heading);
          //console.log("++++++++++++++++++++++++++++++++++++++++++");

          //this.chk_music_station()
          this.drawRoute();

        }
        else if (data.type === 'RealTimeNavigation')
        {
          /*
          //当前站点信息
          this.currentPoint = 'You are now at Point ' + this.nextStationName;
          */
        }
        else if (data.type === 'HMIStatus')
        {
          //当前站点信息{"type":"HMIStatus","timestamp":1599494908454,"modes":0}
          if (data.modes === 2 || data.modes === 1 ||data.modes === "PAUSE") {    // 2=Pause, 1=Manual
            console.log("===== Manual =====");
            this.isStart = false;
          } else if (data.modes === 0 || data.modes === "AUTO") {                 // 0=Stop
            console.log("===== AUTO =====");
            this.isStart = true;
          } else {                                                                // any other => START
            this.isStart = false;
          }

          //this.chk_station()
          this.drawRoute();
        }
      }
    },







    // ********************************************************************************************
    // ***************************        WebSocket to Server      ********************************
    // ********************************************************************************************
    createBroadcast(){
      this.BroadClient = new w3cwebsocket(BroadcastUrl);
      this.BroadClient.onerror = (evt) => {
        console.log("Broadcast WebSocket Error : " + BroadcastUrl);
        //断线自动重连
        this.createBroadcast();
      };
      this.BroadClient.onopen = () => {
        console.log("Broadcast WebSocket Client Connected");
        this.websocketConnecting =false;

        // Debug - Get Order
        this.requestCurrentOrder();
      };
      this.BroadClient.onclose = (evt) => {
        console.log("Broadcast WebSocket Closed : " + BroadcastUrl);
        //断线自动重连
        this.createBroadcast();
      };
      this.BroadClient.onmessage = (evt) => {
        this.BroadCallback(evt.data);
        //this.tcpCallback(evt.data);
      };
    },

    BroadcastSend(param) {
      this.BroadClient.send(param);
    },

    // - Mopi2 Command Start / Stop / Goto Next
    // - Cue
    BroadCallback(res) {
      console.log("Received from Server 8888: "+res);

      if (res.indexOf("{") > -1)
      {
        let data = JSON.parse(res);
        //console.log(data);
        // if receive command from somewhere -> route to engine
        if (data.type === 'Mopi2Start')
        {
          this.send({"type": "HMIStatus", "timestamp": Date.now(), "modes": 'AUTO'});
        }
        // if receive command from somewhere -> route to engine
        else if (data.type === 'Mopi2Stop')
        {
          this.send({"type": "HMIStatus", "timestamp": Date.now(), "modes": 'PAUSE'});
        }

        // Usually use to peek data
        else if (data.type === 'AutoDrivingCar')
        {
          this.veh_speed= data.speed.toFixed(0);
          this.loc_lat= data.latitude;
          this.loc_long= data.longitude;
          this.loc_heading= data.heading;

          //console.log("++++++++++++++++++++++++++++++++++++++++++");
          console.log("+++++ lat long heading speed: " + this.loc_lat.toFixed(5) +" " + this.loc_long.toFixed(5) +" " + this.loc_heading.toFixed(2) +" " + this.veh_speed);
          //console.log("+++++ Heading : " + this.loc_heading);
          //console.log("++++++++++++++++++++++++++++++++++++++++++");

          //this.chk_music_station()
          this.drawRoute();

        }
        else if (data.type === 'RealTimeNavigation')
        {
          /*
          //当前站点信息
          this.currentPoint = 'You are now at Point ' + this.nextStationName;
          */
        }
        else if (data.type === 'HMIStatus')
        {
          //当前站点信息{"type":"HMIStatus","timestamp":1599494908454,"modes":0}
          if (data.modes === 2 || data.modes === 1 ||data.modes === "PAUSE") {    // 2=Pause, 1=Manual
            console.log("===== Manual =====");
            this.isStart = false;
          } else if (data.modes === 0 || data.modes === "AUTO") {                 // 0=Stop
            console.log("===== AUTO =====");
            this.isStart = true;
          } else {                                                                // any other => START
            this.isStart = false;
          }

          //this.chk_station()
          this.drawRoute();
        }


        // **************************************
        // ************** 2023 Nara *************
        // **************************************
        else if (data.type === 'nara2023GetCurrentOrder')
        {
          console.log(data.time)

          // ----- New Order A->B -----
          if (data.source === 1)
          {
            this.travelSourceDestText = this.A_TO_B
            this.emptyOrder=0
            this.travelStatusDirection = 1;
            this.travelStatus = this.TRAVEL_STATUS_COMPLETE;
            this.travelButtonText = this.TRAVEL_START_TEXT;
          }
          // ----- New Order B->A -----
          else if (data.source === 2)
          {
            this.travelSourceDestText = this.B_TO_A
            this.emptyOrder=0
            this.travelStatusDirection = 2;
            this.travelStatus = this.TRAVEL_STATUS_COMPLETE;
            this.travelButtonText = this.TRAVEL_START_TEXT;
          }
          // ----- No New Order -----
          else
          {
            this.emptyOrder=1
            this.travelStatusDirection = 0;
            this.travelStatus = this.TRAVEL_STATUS_COMPLETE;
            this.travelButtonText = this.TRAVEL_START_TEXT;
          }


          this.travelSourceDest = data.source
          this.travelStartTime = data.time
          this.travelSourceTime = "出発時間: " + (data.time-data.time%100)/100+"時" + data.time%100+"分"
          this.travelPassengerName1 = data.name1
          this.selectPassengerCount1= data.passenger1
          this.travelPassengerName2 = data.name2
          this.selectPassengerCount2= data.passenger2
          this.travelPassengerName3 = data.name3
          this.selectPassengerCount3= data.passenger3
          this.travelPassengerName4 = data.name4
          this.selectPassengerCount4= data.passenger4
          this.travelPassengerName5 = data.name5
          this.selectPassengerCount5= data.passenger5
          this.travelPassengerName6 = data.name6
          this.selectPassengerCount6= data.passenger6

          if ((this.selectPassengerCount1==0) && (this.selectPassengerCount2==0) && (this.selectPassengerCount3==0) && (this.selectPassengerCount4==0) && (this.selectPassengerCount5==0) && (this.selectPassengerCount6==0))
            this.emptyPassenger=1;
          else
            this.emptyPassenger=0;
        }

      }
    },





    // ********************************************************************************************
    // ***************************           Button Click          ********************************
    // ********************************************************************************************

    indexClick()
    {
      console.log("Index Logo Click")

      this.fullscreen = true

      //console.log(" ##### cueSize= "+ this.cueSize);
      //if (this.cueSize>0) {
      //  this.systemState=1; // 0=chk user name, 1=select destination, 2=confirm destination, 3=running
      //  this.userNameString = this.objcue[0].username + "樣ですか?";
      //}
      //else
      {
        this.systemState=3; // 0=chk user name, 1=select destination, 2=confirm destination, 3=running
        //this.initMap();
        this.$nextTick(() => {
          if (this.map) {
            this.map.remove();
            this.map = null;
            this.marker = null;
          }
          this.initMap();
        });
      }
    },

    clickBtnNameYes()
    {
      this.systemState=2;

      this.$nextTick(() => {
        if (this.map) {
          this.map.remove();
          this.map = null;
          this.marker = null;
        }
        this.initMap();
      });
    },

    clickBtnNameNo()
    {
      this.systemState=2;

      this.$nextTick(() => {
        if (this.map) {
          this.map.remove();
          this.map = null;
          this.marker = null;
        }
        this.initMap();
      });
    },


    // ----- 点击开始/结束按钮 -----
    clickBtn() {
      //先根据指令停车开车
      this.send({"type": "HMIStatus", "timestamp": Date.now(), "modes": this.isStart ? 'PAUSE' : 'AUTO'});

      if (this.isStart) {
        //this.playSound(1);
        this.isStart = false;
      }
      else {
        //this.playSound(2);
        this.isStart = true;
      }
      //this.isStart = !this.isStart;

      /*
      if (!this.isArrivedNext) {
        this.isPoint = true;
        this.currentPoint = 'You are now moving to Point ' + this.nextStationName;
      } else {
        this.isPoint = false;
        this.currentPoint = 'You are now at Point ' + this.nextStationName;
      }
      */
    },









    playSound(soundNo)
    {
      this.$refs.audio1.pause();
      this.$refs.audio2.pause();
      this.$refs.audio3.pause();
      this.$refs.audio4.pause();
      this.$refs.audio5.pause();


      if (soundNo==1)
      {
        this.$refs.audio1.currentTime = 0;
        this.$refs.audio1.play();
      }
      else if (soundNo==2)
      {
        this.$refs.audio2.currentTime = 0;
        this.$refs.audio2.play();
      }
      else if (soundNo==3)
      {
        this.$refs.audio3.currentTime = 0;
        this.$refs.audio3.play();
      }
      else if (soundNo==4)
      {
        this.$refs.audio4.currentTime = 0;
        this.$refs.audio4.play();
      }
      else if (soundNo==5)
      {
        this.$refs.audio5.currentTime = 0;
        this.$refs.audio5.play();
      }

      console.log("----- Play Sound " + soundNo + "  -----");

    },


/*
    chk_music_station()
    {
      let i;
      let location=[this.loc_lat, this.loc_long];

      console.log(this.sound1_played + "  " + this.sound2_played + "  " + this.sound3_played + "  " + this.sound4_played + "  " + this.sound5_played + "  ");

      if (this.chk_point(location, route[this.music_station[0]], this.station_margin) && this.chk_heading(this.loc_heading, this.target_heading_lower[0], this.target_heading_upper[0]))
      {
        console.log("----- Sound Reset -----");
        this.sound1_played=false;
        this.sound2_played=false;
        this.sound3_played=false;
        this.sound4_played=false;
        this.sound5_played=false;
      }
      else if (this.chk_point(location, route[this.music_station[1]], this.station_margin) && this.chk_heading(this.loc_heading, this.target_heading_lower[1], this.target_heading_upper[1]))
      {
        console.log("----- CHk Music 1 PASS -----");
        if (this.sound1_played==false)
        {
          this.playSound(1);
          this.sound1_played=true;
        }
      }
      else if (this.chk_point(location, route[this.music_station[2]], this.station_margin) && this.chk_heading(this.loc_heading, this.target_heading_lower[2], this.target_heading_upper[2]))
      {
        console.log("----- CHk Music 2 PASS -----");
        if (this.sound2_played==false)
        {
          this.playSound(2);
          this.sound2_played=true;
        }
      }
      else if (this.chk_point(location, route[this.music_station[3]], this.station_margin) && this.chk_heading(this.loc_heading, this.target_heading_lower[3], this.target_heading_upper[3]))
      {
        console.log("----- CHk Music 3 PASS -----");
        if (this.sound3_played==false)
        {
          this.playSound(3);
          this.sound3_played=true;
        }
      }
      else if (this.chk_point(location, route[this.music_station[4]], this.station_margin) && this.chk_heading(this.loc_heading, this.target_heading_lower[4], this.target_heading_upper[4]))
      {
        console.log("----- CHk Music 4 PASS -----");
        if (this.sound4_played==false)
        {
          this.playSound(4);
          this.sound4_played=true;
        }
      }
      else if (this.chk_point(location, route[this.music_station[5]], this.station_margin) && this.chk_heading(this.loc_heading, this.target_heading_lower[5], this.target_heading_upper[5]))
      {
        console.log("----- CHk Music 5 PASS -----");
        if (this.sound5_played==false)
        {
          this.playSound(5);
          this.sound5_played=true;
        }
      }


    },
*/

    chk_heading(current_heading, target_heading_lower, target_heading_upper)
    {
      //console.log("????? Heading Current Target : " + current_heading +" " + target_heading);

      // just for small angle
      if ((target_heading_upper<40) && ((current_heading>target_heading_lower) || (current_heading<target_heading_upper)))
      {
        console.log("----- CHk Heading Pass");
        return true;
      }
      else if ((current_heading>target_heading_lower) && (current_heading<target_heading_upper))
      {
        console.log("----- CHk Heading Pass");
        return true;
      }


      console.log("----- CHk Heading False");
      return false;
    },

    chk_point(point, loc, margin)   // point=current    loc=target point
    {
      //console.log("????? Margin : " + margin);
      //console.log("????? Check Point : " + point[0] +" " +point[1]);
      //console.log("????? Loc   Point : " + loc[0] +" " +loc[1]);

      if (loc[0]>(point[0]+margin) || loc[0]<(point[0]-margin)){
        console.log("----- CHk Point False");
        return false;
      }
      if (loc[1]>(point[1]+margin) || loc[1]<(point[1]-margin)){
        console.log("----- CHk Point False");
        return false;
      }


      console.log("----- CHk Point Pass");
      return true;
    },



















    // ***************************************************************************************************
    // **************************    Check whether it stop at proper station    **************************
    // ***************************************************************************************************
    chk_station(){
      let location=[this.loc_lat, this.loc_long];
      let point_checked= false;

      // ----- if Stopped, chk within station range or StopSign range -----
      // ----- update isGo, isStop, route_point, current_station_name, next_station_name
      if (!this.isStart)
      {
        if (this.chk_point(station[0], location, this.station_margin)){   // station 0 -> go up
          this.isGo=false;     // mean go up next
          this.isStop=false;
          this.route_point=station_point[0];
          this.current_station_name=station_name[0];
          this.next_station_name=station_name[1];
          point_checked=true;
        } else if (this.chk_point(station[1], location, this.station_margin)){
          this.isStop=false;
          this.route_point=station_point[1];
          this.current_station_name=station_name[1];
          if (this.isGo)
            this.next_station_name=station_name[0];
          else
            this.next_station_name=station_name[2];
          point_checked=true;
        } else if (this.chk_point(station[2], location, this.station_margin)){
          this.isGo=true;     // will go down next
          this.isStop=false;
          this.route_point=station_point[2];
          this.current_station_name=station_name[2];    // in top
          this.next_station_name=station_name[1];
          point_checked=true;
        }
        /*
        else if (this.chk_point(station[3], location, this.station_margin)){
          this.isStop=false;
          this.route_point=station_point[3];
          this.current_station_name=station_name[3];
          if (this.isGo)
            this.next_station_name=station_name[4];
          else
            this.next_station_name=station_name[2];
          point_checked=true;
        } else if (this.chk_point(station[4], location, this.station_margin)){
          this.isGo=false;     // must go back
          this.isStop=false;
          this.route_point=station_point[4];
          this.current_station_name=station_name[4];
          this.next_station_name=station_name[3];
          point_checked=true;
        } else if (this.chk_point(stop_pos, location, this.station_margin)){
          this.isStop=true;
          this.route_point=58;
          if (this.isGo) {
            this.current_station_name = station_name[0];
            this.next_station_name = station_name[1];
          }
          else{
            this.current_station_name=station_name[1];
            this.next_station_name=station_name[0];
          }
          point_checked=true;
        }
        */
      }

      // ----- if Running, chk within point range -----
      // ----- update route_point
      if (point_checked==false)
      {
         let i;
         for (i=0;i<route.length;i++){
           if (this.chk_point(route[i],location, this.station_margin)) {
             this.route_point = i;
             this.isStop = false;
             i = 1000;
           }
         }

         //if (i==1001)   // route point updated
         if (i==9999)     // disabled - never use
         {
           let point_margin;

           // Station 0<->1
           point_margin=(station_point[1]-station_point[0])/3;
           console.log("***** Point Margin : " + point_margin);
           if ( (this.route_point>(station_point[0]+point_margin)) && (this.route_point<(station_point[1]-point_margin))) {
             if(this.isGo) {
               this.current_station_name=station_name[0];
               this.next_station_name   =station_name[1];
             } else {
               this.current_station_name=station_name[1];
               this.next_station_name   =station_name[0];
             }
           }

           // Station 1<->2
           point_margin=(station_point[2]-station_point[1])/3;
           console.log("***** Point Margin : " + point_margin);
           if ( (this.route_point>(station_point[1]+point_margin)) && (this.route_point<(station_point[2]-point_margin))) {
             if(this.isGo) {
               this.current_station_name=station_name[1];
               this.next_station_name   =station_name[2];
             } else {
               this.current_station_name=station_name[2];
               this.next_station_name   =station_name[1];
             }
           }
           /*
           // Station 2<->3
           point_margin=(station_point[3]-station_point[2])/3;
           console.log("***** Point Margin : " + point_margin);
           if ( (this.route_point>(station_point[2]+point_margin)) && (this.route_point<(station_point[3]-point_margin))) {
             if(this.isGo) {
               this.current_station_name=station_name[2];
               this.next_station_name   =station_name[3];
             } else {
               this.current_station_name=station_name[3];
               this.next_station_name   =station_name[2];
             }
           }
           // Station 3<->4
           point_margin=(station_point[4]-station_point[3])/3;
           console.log("***** Point Margin : " + point_margin);
           if ( (this.route_point>(station_point[3]+point_margin)) && (this.route_point<(station_point[4]-point_margin))) {
             if(this.isGo) {
               this.current_station_name=station_name[3];
               this.next_station_name   =station_name[4];
             } else {
               this.current_station_name=station_name[4];
               this.next_station_name   =station_name[3];
             }
           }
           */

         }


      }
      console.log("**********");
      console.log("***** Route Point : " + this.route_point);
      console.log("**********");
    },










    //更新车辆位置
    updateCarPosition(position, heading) {
      //this.map.panTo(position, 18);

      this.marker.slideTo(position, {
        //rotationAngle: heading,
        duration: 20,
        rotationOrigin: "center center"
      });
    },


    //根据标注点位画标注
    drawMarker() {
      /*
      for (let marker of markers) {
        this.L.marker(marker.lng)
          .addTo(this.map)
          .addTo(this.map)
          .on("click", () => {
            marker.id !== undefined &&
              this.client &&
              this.client.readyState === 1 &&
              this.client.send(
                JSON.stringify({
                  type: "RequestStationInfo",
                  station_id: marker.id,
                  lang: this.$i18n.locale
                })
              );
          });
      }
      */

      /*
        // Creating a Marker
        let markerOptions = {
          title: "MyLocation",
          clickable: true,
          draggable: true
        }
        */


      // Icon options
      let iconOptions = {
        iconUrl: '../assets/publicroad/dot.png',
        //iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
        //iconSize: [102, 102]
        iconSize: [40, 40],
      }
      // Creating a custom icon
      let customIcon = this.L.icon(iconOptions);

      let i;
      for (i = 0; i < station_name.length; i++)
      {
        // Creating Marker Options
        let markerOptions = {
          title: station_name[i],
          clickable: true,
          draggable: true,
          //icon: customIcon
        }
        // Creating a Marker
        let marker = this.L.marker(station[i], markerOptions);
        // Adding popup to the marker
        marker.bindPopup(station_name[i]).openPopup();
        // Adding marker to the map
        marker.addTo(this.map);

      }

    },

    toggleDir() {
      this.isGo = !this.isGo;
      //this.route_point+=50;
      //this.loc_lat = 35.1628012;
      //this.loc_long = 137.8680675;
      //this.isStop = !this.isStop;

      //this.chk_station()
      this.drawRoute();
    },






























    // ********************************************************************************************
    // ***************************                  OLD Code       ********************************
    // ********************************************************************************************

    // 返回lang页选择语言
    backToLang() {
      //this.isStart = !this.isStart;
      //this.drawRouter(route);
      //this.drawMarker();
      //this.$router.push({
      //  path: "/"
      //});
    },

    //用于时间更新
    updateTime() {
      this.timer = setInterval(() => {
        this.time = moment().format("LT");
      }, 1000);
    },

    //路径以及标注数据适配
    formatRoutes(routes) {
      if (!routes) return;

      let points = [], //路径点
        markers = []; //标注点

      let startPosition = wgs84togcj02(
        routes.startPoint.longitude,
        routes.startPoint.latitude
      ).reverse();
      points.push(startPosition);

      if (routes.startPoint.isStation) {
        markers.push({
          lng: startPosition,
          id: routes.startPoint.stationId
        });
      }

      for (let point of routes.points) {
        let { latitude, longitude, isStation, stationId } = point;

        let position = wgs84togcj02(longitude, latitude).reverse();
        points.push(position);

        isStation &&
          markers.push({
            lng: position,
            id: stationId
          });
      }

      let endPosition = wgs84togcj02(
        routes.endPoint.longitude,
        routes.endPoint.latitude
      ).reverse();
      points.push(endPosition);

      if (routes.endPoint.isStation) {
        markers.push({
          lng: endPosition,
          id: routes.endPoint.stationId
        });
      }

      return {
        points,
        markers
      };
    },

    async drawRoutesAndMarkers(routes) {
      let { points, markers } = this.formatRoutes(routes);

      //根据坐标点画线路图
      this.drawRouter(points);

      //根据标注点画标注图
      this.drawMarker(markers);
    },

    //根据坐标点位画路线
    drawRouter(points) {
      let polyline = this.L.polyline(points, {
        //color: "#bc4be5",
        color: "#13b49b",
        weight: 5
      }).addTo(this.map);

      this.map.fitBounds(polyline.getBounds());
    },




    //建立websocket连接
    createWSOri(url, looptTime) {
      let client = new w3cwebsocket(url);

      client.onerror = () => {
        console.error("Connection Error");
      };

      client.onclose = () => {
        this.reconnection(true);
        this.websocketConnecting =true;
        console.log("Client Closed");
      };

      return client;
    },





    //websocket处理函数
    processWS(url, looptTime = 100)
    {
      this.client = this.createWSOri(url, looptTime);

      this.client.onopen = () => {
        console.log("WebSocket Client Connected");
        this.websocketConnecting =false;
      };


      // Request simulation world every 100ms.
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if (this.client.readyState === this.client.OPEN) {
          this.requestSimulationWorld();
        }
      }, 100);

      // Request RealTimeRoute every 1000ms.
      clearInterval(this.timer2);
      this.timer2 = setInterval(() => {
        if (this.client.readyState === this.client.OPEN) {
          this.requestRealTimeRoute();
        }
      }, 1000);




      // ----------------------------------------------
      // --------------- Socket Message ---------------
      // ----------------------------------------------
      this.client.onmessage = async ({ data }) => {
        if (data) {
          let message = null;
          try {
            message = JSON.parse(data);
          } catch (error) {
            console.warn(`Failed to parse string ${data}.`);
            return;
          }

          if (message.type === "RoutePath") {
            await this.drawRoutesAndMarkers(message);
          } else if (message.type === "AutoDrivingCar") {
            let {
              battery_level,
              gear_position,
              heading,
              latitude,
              longitude,
              speed,
              vehicle_status,
              steer_angle
            } = message;

            this.carInfo = {
              speed: speed ? speed.toFixed(0) : 0,
              batteryLevel: parseInt(battery_level * 100),
              gearPosition: gear_position.substr(0, 1)
            };

            if (heading && latitude && longitude) {
              let position = wgs84togcj02(longitude, latitude).reverse();

              if (this.marker) {
                this.updateCarPosition(position, heading);
              } else {
                this.marker = this.drawCardrawCar(position, heading);
              }
            }

            if (vehicle_status !== undefined) {
              this.isAuto = vehicle_status == 5 ? false : true;
              this.signSrc = sign[vehicle_status - 1];

              if (vehicle_status == 0) {
                this.signSrc = sign[4];
              }

              if (vehicle_status == 1) {
                this.turnSrc = left;
                this.isTurn = true;
              } else if (vehicle_status == 2) {
                this.turnSrc = right;
                this.isTurn = true;
              } else {
                this.isTurn = false;
              }
            }

            if (steer_angle) {
              this.rotate = steer_angle;
            } else {
              this.rotate = 0;
            }
          } else if (message.type === "SimulationWorld") {
            let { object } = message;

            Array.isArray(object) && (this.obstacles = object);
          } else if (message.type === "RealTimeNavigation") {
            let { next_station_name, next_station_timing } = message;

            this.station = {
              name: next_station_name,
              time: next_station_timing
            };
          } else if (message.type === "pong") {
            //心跳包
            this.client &&
              this.client.readyState === 1 &&
              this.client.send(
                JSON.stringify({
                  type: "ping"
                })
              );
          } else if (message.type === "HMIStatus") {
            let { current_mode } = message;

            if (current_mode == 0)
            {
              this.isAuto = true;
              this.isStart = true;
            } else if (current_mode == 1 || current_mode == 2)
            {
              this.isAuto = false;
              this.isStart = false;
            }
          } else if (message.type === "StationInfo") {
            this.visible = true;
            this.stationName = message.station_name;
            this.stationTime = message.station_timing;
            this.stationUrl = message.station_url;
          }
        }
      };
    },



    /*
    requestSimulationWorld() {
      this.client.send(
        JSON.stringify({
          type: "RequestSimulationWorld"
          //  planning : requestPlanningData,
        })
      );
    },
    requestRealTimeRoute() {
      this.client.send(
        JSON.stringify({
          type: "RequestRealTimeNavigation"
        })
      );
    },
    */



    //websocket心跳机制
    reconnection(flag = false) {
      if (flag) {
        if (this.reconnectionTimer) {
          return false;
        }

        this.reconnectionTimer = setTimeout(() => {
          console.log("reconnection!!!");

          if (this.map) {
            this.map.remove();
            this.map = null;
            this.marker = null;
          }

          this.initMap();
          this.processWS(WSURL);

          clearTimeout(this.reconnectionTimer);
          this.reconnectionTimer = null;
        //}, 5000);
        }, 1000000);    // Patrick debug
      }
    },

    //临时停车
    tempHandler() {
      this.isTempStart = !this.isTempStart;
      this.tempSrc = this.isTempStart ? stop : start;

      this.client &&
        this.client.readyState === 1 &&
        this.client.send(
          JSON.stringify({
            type: "HMIStatus",
            timestamp: Date.now(),
            modes: this.isTempStart ? "PAUSE" : "RESUME"
          })
        );
    },

    //去往目的地
    gotoDest() {
      this.client &&
        this.client.readyState === 1 &&
        this.client.send(
          JSON.stringify({
            //TODO 去往选定的目的地
          })
        );
    },



    //自动、手动切换
    // ---------------------------------------------------
    // --------------- START / STOP Button ---------------
    // ---------------------------------------------------
    operate() {

      this.isStart = !this.isStart;

      this.client &&
        this.client.readyState === 1 &&
        this.client.send(
          JSON.stringify({
            type: "HMIStatus",
            timestamp: Date.now(),
            modes: this.isStart ? "AUTO" : "PAUSE"
          })
        );
    },


    //缓存log日志
    cacheLog() {
      this.client &&
        this.client.readyState === 1 &&
        this.client.send(
          JSON.stringify({
            type: "HMIStatus",
            timestamp: Date.now(),
            enable_log: true
          })
        );
    },

    //紧急电话
    callPhone() {
      this.client &&
        this.client.readyState === 1 &&
        this.client.send(
          JSON.stringify({
            type: "HMIStatus",
            timestamp: Date.now(),
            enable_phone_call: true
          })
        );
    },
    //module reboot
    moduleStart() {
      this.client &&
        this.client.readyState === 1 &&
        this.client.send(
          JSON.stringify({
            type: "HMIStatus",
            timestamp: Date.now(),
            modes: "MODULE_START"
          })
        );
    },
    //关机
    shutDown() {
      this.client &&
        this.client.readyState === 1 &&
        this.client.send(
          JSON.stringify({
            type: "HMIStatus",
            timestamp: Date.now(),
            modes: "POWEROFF"
          })
        );
    }
  },





  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }



};

</script>





















<style scoped>

/*  -----------------------------------------------------------------------------
    -----------------------------------------------------------------------------
    ------------------------------        Index     -----------------------------
    -----------------------------------------------------------------------------
    -----------------------------------------------------------------------------
*/
.index-container {
  /* */
  display: flex;
  height: 100%;
  width: 100%;

  background: #fff;
  position: relative;
  font-size: 60px;
}
.index {
  position: absolute;
  top: 30%;
  left: 0;
  right: 0;
  margin: 0 auto;
  text-align: center;
}
.index-logo{
  width: 81px;
  height: 134px;
  margin-bottom: -20px;
}
.index-txt{
  padding-left: 20px;
}

.mainlogo{
  width: 195px;
  height: 67px;
  position:fixed;
  bottom:50px;
  left:50%;
  margin-left: -100px;
}



/*  -----------------------------------------------------------------------------
    -----------------------------------------------------------------------------
    ------------------------------  User Selection  -----------------------------
    -----------------------------------------------------------------------------
    -----------------------------------------------------------------------------
*/
.mainPanel{
  display: flex;
  flex-direction: row;
  background-color: white;
  align-items: center;
  align-content: center;
  justify-content: center;
  width: 75%;
  height: 100%;
}

.travelClass{
  display: flex;
  flex-direction: column;
  background-color: white;
  width: 100%;
  height: 100%;
  margin-left: 30px;
}

.travelTitleClass {
  display: flex;
  flex-direction: row;
  height: 5%;

  justify-content: center;
  /*
    margin-top: 10px;
    margin-bottom: auto;     align-top
    */

  font-size:25px;
  font-weight: bold;
  color: #000000;
}

.travelLineClass{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 5%;

  font-size:25px;
  font-weight: bold;
  color: #000000;
}

.travelPassLineClass{
  display: flex;
  flex-direction: row;
  height: 5%;
  margin-left: 10%;
  margin-top: 5px;

  font-size:25px;
  font-weight: bold;
  color: #000000;
  background-color: #ffffff;
}

.travelPassNameClass{
  position: relative;
  width: 300px;
  justify-content: center;
  text-align: center;
  border-top-style: ridge;
  border-right-style: ridge;
  border-left-style: ridge;
  border-bottom-style: ridge;

  font-size:25px;
  font-weight: bold;
  color: #000000;
}

.travelCountoptionbox{
  /*用div的样式代替select的样式*/
  width: 300px;
  text-align: center;
  font-size:25px;
  /*border-radius: 5px;*/
  /*盒子阴影修饰作用,自己随意*/
  /* box-shadow: 0 0 5px #ccc;*/
  border-top-style: ridge;
  border-right-style: ridge;
  border-left-style: ridge;
  border-bottom-style: ridge;
  background-color: #ffffff;
  position: relative;
  margin-left: 20px;
}

.travelPassLineClass{
  display: flex;
  flex-direction: row;
  height: 5%;
  margin-left: 10%;

  font-size:25px;
  font-weight: bold;
  color: #000000;
  background-color: #ffffff;
}

.travelOrderEmptyClass{
  display: flex;
  flex-direction: row;
  width:100%;
  height: 10%;
  justify-content: center;  /* left/right center */
  align-items: center;      /* up/down center */
  margin-top: 15%;
  font-size:40px;
  font-weight: bold;
  color: #000000;
}

.travelButtonClass {
  display: flex;
  flex-direction: row;
  width:10%;
  height: 5%;
  margin-left: 45%;
  margin-top: auto;
  margin-bottom: 20px;
  justify-content: center;  /* left/right center */
  align-items: center;      /* up/down center */
  border-radius: 10px;
  border-top-style: solid;
  border-right-style: solid;
  border-left-style: solid;
  border-bottom-style: solid;

  font-size:30px;
  font-weight: bold;
  color: #000000;
}









.selectstyle
{
  font-size:25px;
}


.mainPanelCenterContent{
  font-size:35px;
  font-weight: bold;
  display: flex;
  flex-direction: column;
  background-color: white;
  align-items: center;
  align-content: center;
  justify-content: center;
  width: 90%;
  height: 100%;
}



.haveOrder {
  display: flex;
  flex-direction: column;
  flex-wrap:wrap-reverse;
  background-color: white;
  margin-left: auto;
  align-items: center;
  align-content: center;
  width: 25%;
  height: 100%;
}

.yesBlk {
  text-align: center;
  margin-left: auto;
  padding:0px;
  width: 100%;
  height: 50%;
  background-color: #13b49b;
}

.noBlk {
  text-align: center;
  margin-left: auto;
  padding:0px;
  width: 100%;
  height: 50%;
  background-color: #C7CCD5;
}

.stationButtonOdd
{
  font-size:35px;
  font-weight: bold;
  color: #fff;
  text-align: center;
  margin-left: auto;
  padding:0px;
  border: 0;
  width: 100%;
  height: 100%;
  background-color: #13b49b;
}
.stationButtonEven
{
  font-size:35px;
  font-weight: bold;
  color: #000;
  text-align: center;
  margin-left: auto;
  padding:0px;
  border: 0;
  width: 100%;
  height: 100%;
  background-color: #C7CCD5;
}





/*  -----------------------------------------------------------------------------
    -----------------------------------------------------------------------------
    ------------------------------       Map        -----------------------------
    -----------------------------------------------------------------------------
    -----------------------------------------------------------------------------
*/
.map {
  display: flex;
  background-color: rgba(29, 0, 65, 1);
  text-align: justify;
  width: 100%;
  height: 100%;

  border: 0;
  justify-content: center;
  margin-left: 0px;
  margin-right: 0px;

  /*
    flex: 1;
    position: relative;
    overflow: hidden;
    */
}











.main-wrapper {
  height: 100%;
  width: 100%;
  display: flex;
  position: relative;
  overflow: hidden;
}

.main {
  background: linear-gradient(to bottom, #f8f9fc 0%, #f2f7f9 100%);
  box-shadow: 4px 0 15px rgba(0, 0, 0, 0.2);
  z-index: 999;
  display: flex;
  flex-direction: column;
  position: absolute;
  margin-top: 20px;
  margin-left: 30px;
}

.header {
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  justify-content: right;
}

.time {
  font-weight: 400;
  color: rgba(29, 38, 65, 1);
}

.sign {
  /*
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
   */
  display: flex;
  margin-right: 2%;
}


.speed_block{
  /*
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  */
  display: inline-block;
  position: relative;
}

.speed {
  /*
  width: 50%;
  left: 0%;
  right: 0%;
  text-align: center;
  position: absolute;
  font-weight: bold;
  color: rgba(29, 38, 65, 1);
  display: flex;
  flex-direction: row;
  justify-content: center;
  */
  position: absolute;
  text-align: center;
  left: 0%;
  right: 0%;
}
.unit {
/*
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  flex: 1;
  display: flex;
*/
  position: absolute;
  text-align: right;
  vertical-align: text-bottom;
  top: 30px;
  right: 2%;
}
.line {
  height: 3px;
  width: 100%;
  background: rgba(0, 0, 0, 1);
}


.body {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.stop_logo {
  display: flex;
}
.stopsign_logo {
  display: flex;
}
.car_logo {
  display: flex;
}

.station_block{
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.next_station {
  display: flex;
  text-align: center;
}
.station_name {
  display: flex;
  text-align: center;
  font-weight: bold;
}
.stop_sign_1{
  display: flex;
  text-align: center;
}
.stop_sign_2{
  display: flex;
  text-align: center;
  font-weight: bold;
}
.stop_sign_3{
  display: flex;
  text-align: center;
}

.footer {
  display: flex;
  position: absolute;
}
.start {
  flex: 1;
  /* box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.16); */
  color: #fff;
  border: none;
}



.info {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  color: #484848;
  position: relative;
}

.electricity {
  height: 20px;
  width: 100px;
}

.split {
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}


.block {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.wheel {
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.drive {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 10px;
}

.mask {
  height: 100%;
  width: 100%;
  z-index: 10;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.canvas {
  height: 100%;
  width: 100%;
}

.msg {
  display: flex;
  flex-direction: row;
  padding-bottom: 10px;
}

.station,
.duration {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.key {
  font-weight: 400;
  color: rgba(128, 132, 143, 1);
  white-space: nowrap;
}

.value {
  font-weight: 400;
  line-height: 49px;
  color: rgba(28, 28, 28, 1);
}

.temp {
  padding: 20px;
  background: rgba(255, 177, 0, 1);
  box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.16);
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: none;
  margin-right: 10px;
}



@media screen and (min-width: 2048px) {
  .main {
    width: 660px;
    padding: 48px;

    position: absolute;
    margin-top: 50px;
    margin-left: 50px;
    margin-bottom: 50px;

  }

  .time {
    font-size: 44px;
    line-height: 82px;
  }

  .sign {
    height: 120px;
    width: 110px;
  }

  .speed_block {
    height: 250px;
  }

  .speed {
    font-size: 200px;
    line-height: 200px;
  }

  .unit {
    font-size: 30px;
    line-height: 250px;
  }

  .stop_logo {
    height: 118px;
    width: 114px;
  }
  .stopsign_logo {
    margin-top: 20%;
    height: 144px;
    width: 157px;
  }
  .car_logo  {
    height: 118px;
    width: 114px;
  }
  .next_station {
    font-size: 30px;
    line-height: 100px;
  }
  .station_name {
    font-size: 40px;
    line-height: 150px;
  }
  .stop_sign_1{
    font-size: 30px;
    line-height: 100px;
  }
  .stop_sign_2{
    font-size: 30px;
    line-height: 100px;
  }
  .stop_sign_3{
    font-size: 30px;
    line-height: 100px;
  }

  .footer{
    width: 240px;
    height: 60px;
    line-height: 60px;
  }
  .start {
    height: 88px;
    font-size: 38px;
    /* border-radius: 88px; */
    border-radius: 0px;
  }



  .block {
    top: -28px;
  }
  .drive {
    height: 600px;
  }

  .key {
    font-size: 28px;
    line-height: 82px;
  }

  .value {
    font-size: 40px;
    line-height: 49px;
  }

  .temp {
    width: 88px;
    height: 88px;
    border-radius: 88px;
  }


}

@media screen and (max-width: 1920px) {
  .main {
    width: 300px;
    height: 95%;
    padding: 30px;
  }


  .speed_block {
    height: 100px;
  }
  .speed {
    font-size: 100px;
    line-height: 100px;
  }
  .unit {
    font-size: 20px;
    line-height: 100px;
  }


  .stop_logo {
    margin-top: 5%;
    height: 118px;
    width: 114px;
  }
  .stopsign_logo {
    margin-top: 20%;
    margin-bottom: 10%;
    height: 144px;
    width: 157px;
  }
  .car_logo  {
    margin-top: 10%;
    height: 124px;
    width: 202px;
  }
  .next_station {
    margin-top: 5%;
    font-size: 20px;
    line-height: 20px;
  }
  .station_name {
    margin-top: 10%;
    font-size: 25px;
    line-height: 25px;
  }
  .stop_sign_1{
    font-size: 25px;
    line-height: 30px;
  }
  .stop_sign_2{
    font-size: 25px;
    line-height: 30px;
  }
  .stop_sign_3{
    font-size: 25px;
    line-height: 30px;
  }


  .footer{
    width: 240px;
    height: 50px;
    line-height: 60px;
    bottom: 5%;
  }
  .start {
    width: 240px;
    height: 50px;
    font-size: 30px;
    /* border-radius: 68px; */
    border-radius: 0px;
  }









  .time {
    font-size: 35px;
    line-height: 64px;
  }

  .sign {
    height: 43px;
    width: 43px;
  }

  .block {
    top: -28px;
  }

  .drive {
    height: 520px;
  }

  .key {
    font-size: 22px;
    line-height: 64px;
  }

  .value {
    font-size: 32px;
    line-height: 30px;
  }

  .temp {
    width: 68px;
    height: 68px;
    border-radius: 68px;
  }

}

picture {
  display: flex;
  align-items: center;
  justify-content: center;
}



.home {
  height: 70px;
  width: 120px;
  position: absolute;
  top: 20px;
  left: 0;
  background: #fff;
  box-shadow: 0 20px 30px 0 rgba(0, 0, 0, 0.16);
  border-radius: 0 88px 88px 0;
  z-index: 9989;
  display: flex;
  align-items: center;
  justify-content: center;
}


.log,
.phone,
.close {
  position: absolute;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.16);
  border-radius: 44px 0px 0px 44px;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}


.logo {
  top: 20px;
  right: 0;
  width: 220px;
}



.log {
  height: 100px;
  width: 100px;
  bottom: 280px;
  right: 38px;
  border-radius: 50%;
}

.phone {
  height: 100px;
  width: 100px;
  bottom: 160px;
  right: 38px;
  border-radius: 50%;
}

.close {
  height: 100px;
  width: 100px;
  bottom: 40px;
  right: 38px;
  border-radius: 50%;
}

.shut {
  height: 80px;
  font-family: PingFang-SC-Bold;
  font-size: 40px;
  color: #1c1c1c;
  text-align: center;
  line-height: 40px;
}
</style>
